<template>
  <div>
    <div class="mapDisplay">
      <div id="map" ref="googleMap"></div>
      <div ref="station_data" class="stationDataDisplay" style="display: none">
        <weather-station-data v-if="selectedStation !== null" :station="selectedStation"></weather-station-data>
      </div>
    </div>
    <div class="" style="position: relative; top: -16px; display: none" ref="weatherPopup">
      <current-conditions-popup :station="selectedStation" :isHighlighted="isSelectedStationMine" :isLoggedIn="isLoggedIn" v-if="selectedStation !== null"></current-conditions-popup>
    </div>

  </div>
</template>

<script>

import 'ol/ol.css'
import bus from "../bus"
import counties from "../counties"
import GoogleMapsApiLoader from 'google-maps-api-loader'
import WeatherStationDataView from './WeatherStationDataView'
import CurrentConditionsPopup from './CurrentConditionsPopup'
import API from "@/api";

let WeatherPopup = null;

const GOOGLE_MAPS_API_KEY = process.env.VUE_APP_GOOGLE_MAPS_API_KEY;


export default {
  name: 'PublicWeatherMap',
  components: {
    'current-conditions-popup': CurrentConditionsPopup,
    'weather-station-data': WeatherStationDataView
  },
   props: {
     mapConfig: Object,

     stations: Array
  },
  data: function() {
    return {
      google: null,
      map: null,
      selectedStation: null,
      myStationIds: [],
      markers: [],
      isLoggedIn: API.isLoggedIn(),
    };
  },
  async mounted() {
    bus.$on('session-login', () => {
      this.isLoggedIn = true;
    });
    bus.$on('session-logout', () => {
      this.isLoggedIn = false;
    });

    this.google = await GoogleMapsApiLoader({apiKey: GOOGLE_MAPS_API_KEY});

    // Listen to events emitted by children
    bus.$on("close-popup", this.closePopup);

    WeatherPopup = createWeatherPopupClass();

    // Keep a single instance of the weather popup on the component.
    this.popup = null;

    this.map = this.buildGoogleMap();

    counties.forEach(county => {
      let p = new this.google.maps.Polyline({
        path: county.coords,
        strokeColor: '#79D9D2',
        strokeWeight: 2
      });

      p.setMap(this.map);
      p.addListener("click", () => {
        // hide any popups when clicked
        this.deselectStation();
      });
    });

    this.updateMarkers();

  },
  computed: {
    isSelectedStationMine() {
      if (this.selectedStation === null) {
        return false;
      }

      return this.myStationIds.find((id) => this.selectedStation.id === id);
    },
    doesSelectedStationHaveData() {
      if (this.selectedStation === null) {
        return false;
      }
      return this.selectedStation.location !== undefined;
    }
  },
  methods: {
    buildGoogleMap() {
      let map = new this.google.maps.Map(
        this.$refs.googleMap, {
          center: { lat: 40.52325, lng: -86.90867},
          zoom: 9,
          //mapTypeId: 'road',
          zoomControl: true,
          mapTypeControl: false,
          clickableIcons: false,
          scaleControl: false,
          streetViewControl: false,
          rotateControl: false,
          fullscreenControl: false,
          // from snazzymaps
          styles: snazzy_maps_styles
        });
      return map;
    },
    updateMarkers() {
      if (!this.google) {
        return;
      }

      // remove all
      this.markers.forEach(s => s.marker.setMap(null));
      let oldSelectedStationName = (this.selectedStation) ? this.selectedStation.name : null;

      this.markers = [];
      this.selectedStation = null;

      const stations_with_markers = this.stations.map(station => {
        let [lng, lat] = [null,null];
        let hasData = (station.observation_time !== undefined);
        if (station.longitude !== undefined) {
          [lng, lat] = [station.longitude, station.latitude];
        } else {
          [lng, lat] = station.location.slice(6, -1).split(' ').map(parseFloat);
        }
        return {
          marker: new this.google.maps.Marker({
              position: {lat, lng},
              map: this.map,
              title: station.name,
              //label: {text: `${station.temp}`, color: 'white', fontSize: '15px', fontWeight: 'normal'},
              icon: {
                url: (hasData) ? './icons/marker.svg' : './icons/faded_marker.svg',
                anchor: new this.google.maps.Point(10,19),
                scaledSize: new this.google.maps.Size(20, 20),
              }
            }),
          station: station,
        }
      });

      // GM handlers are sometimes called overriding `this`

      stations_with_markers.forEach(s => {
        let {marker, station} = s;

        marker.addListener('click', this.handleMarkerClicked.bind(this, marker, station));
      });

      // Close any open popup window when the map is clicked
      this.map.addListener('click', this.handleMapClicked.bind(this));

      this.markers = stations_with_markers;
      if (oldSelectedStationName) {
        let stationMatch = this.stations.find(s => s.name === oldSelectedStationName);
        if (stationMatch) {
          this.selectedStation = stationMatch;
        }
      }
    },
    handleMapClicked() {
      this.closePopup();
    },
    handleMarkerClicked(marker, station) {

      // Remove current popup from map if it is showing
      this.closePopup();

      // If we are clicking on a new station, show a new popup.
      if (this.selectedStation !== station) {
        this.showPopup(marker.position, station);
      }
    },
    isPopupShowing() {
      return this.popup !== null;
    },
    selectStation(station) {
      this.selectedStation = station;
      bus.$emit("StationSelected", {station: station});
    },
    deselectStation() {
      this.selectedStation = null;
      bus.$emit("StationSelected", {station: null});
    },
    showPopup(position, station) {
      // Create popup for this marker and show it.
      this.popup = new WeatherPopup(position, this.$refs.weatherPopup, this.map);
      this.popup.setMap(this.map);

      // Set the selected station to what was clicked.
      this.selectStation(station);
    },
    closePopup() {
      if (this.popup !== null) {
        this.popup.setMap(null);
        this.popup = null;

        this.deselectStation();
      }
    }
  },

  watch: {
    stations() {
      // update current station data
      this.updateMarkers();
    }
  }
}


function createWeatherPopupClass() {
  /**
   * A customized popup on the map.
   * @param {!google.maps.LatLng} position
   * @param {!Element} content The bubble div.
   * @constructor
   * @extends {google.maps.OverlayView}
   */
  function Popup(position, content, map) {
    this.position = position;
    this.content = content;
    this.map = map;

    this.containerDiv = document.createElement('div');
    this.containerDiv.classList.add('popup-container');
    //content.classList.add('popup-bubble');

    // This zero-height div is positioned at the bottom of the bubble.
    //var bubbleAnchor = document.createElement('div');
    //bubbleAnchor.classList.add('popup-bubble-anchor');
    //bubbleAnchor.appendChild(content);


  }
  // extend google.maps.OverlayView.
  Popup.prototype = Object.create(google.maps.OverlayView.prototype);

  /** Called when the popup is added to the map. */
  Popup.prototype.onAdd = function() {


    this.containerDiv.appendChild(this.content);


    // Optionally stop clicks, etc., from bubbling up to the map.
    google.maps.OverlayView.preventMapHitsAndGesturesFrom(this.containerDiv);

    this.getPanes().floatPane.appendChild(this.containerDiv);
    //this.containerDiv.classList.remove("slideup");
    //this.containerDiv.classList.add("slidedown");

    // Center the map on the approximate middle of the popup
    let pixelPos = this.getProjection().fromLatLngToDivPixel(this.position);
    // Marker width and height / 2 is approximate
    pixelPos.x += 140/2;
    pixelPos.y += 200/2;
    let newPos = this.getProjection().fromDivPixelToLatLng(pixelPos);
    this.map.panTo(newPos);

  };

  /** Called when the popup is removed from the map. */
  Popup.prototype.onRemove = function() {
    //this.containerDiv.classList.replace("fadein", "fadeout");
    if (this.containerDiv.parentElement) {
      this.containerDiv.parentElement.removeChild(this.containerDiv);
    }
  };

  /** Called each frame when the popup needs to draw itself. */
  Popup.prototype.draw = function() {

    // Enable content display
    this.content.style.display = "block";

    var divPosition = this.getProjection().fromLatLngToDivPixel(this.position);

    // Hide the popup when it is far out of view.
    var display =
        Math.abs(divPosition.x) < 4000 && Math.abs(divPosition.y) < 4000 ?
        'block' :
        'none';

    if (display === 'block') {
      this.containerDiv.style.left = divPosition.x + 'px';
      this.containerDiv.style.top = divPosition.y + 'px';
    }
    if (this.containerDiv.style.display !== display) {
      this.containerDiv.style.display = display;
    }
  };

  return Popup;
}


const snazzy_maps_styles = [
    {
      "featureType": "all",
      "elementType": "geometry.fill",
      "stylers": [
        {
          "weight": "2.00"
        }
      ]
    },
    {
      "featureType": "all",
      "elementType": "geometry.stroke",
      "stylers": [
        {
          "color": "#9c9c9c"
        }
      ]
    },
    {
      "featureType": "all",
      "elementType": "labels.text",
      "stylers": [
        {
          "visibility": "on"
        }
      ]
    },
    {
      "featureType": "landscape",
      "elementType": "all",
      "stylers": [
        {
          "color": "#f2f2f2"
        }
      ]
    },
    {
      "featureType": "landscape",
      "elementType": "geometry.fill",
      "stylers": [
        {
          "color": "#ffffff"
        }
      ]
    },
    {
      "featureType": "landscape.man_made",
      "elementType": "geometry.fill",
      "stylers": [
        {
          "color": "#ffffff"
        }
      ]
    },
    {
      "featureType": "poi",
      "elementType": "all",
      "stylers": [
        {
          "visibility": "off"
        }
      ]
    },
    {
      "featureType": "road",
      "elementType": "all",
      "stylers": [
        {
          "saturation": -100
        },
        {
          "lightness": 45
        }
      ]
    },
    {
      "featureType": "road",
      "elementType": "geometry.fill",
      "stylers": [
        {
          "color": "#eeeeee"
        }
      ]
    },
    {
      "featureType": "road",
      "elementType": "labels.text.fill",
      "stylers": [
        {
          "color": "#7b7b7b"
        }
      ]
    },
    {
      "featureType": "road",
      "elementType": "labels.text.stroke",
      "stylers": [
        {
          "color": "#ffffff"
        }
      ]
    },
    {
      "featureType": "road.highway",
      "elementType": "all",
      "stylers": [
        {
          "visibility": "simplified"
        }
      ]
    },
    {
      "featureType": "road.arterial",
      "elementType": "labels.icon",
      "stylers": [
        {
          "visibility": "off"
        }
      ]
    },
    {
      "featureType": "transit",
      "elementType": "all",
      "stylers": [
        {
          "visibility": "off"
        }
      ]
    },
    {
      "featureType": "water",
      "elementType": "all",
      "stylers": [
        {
          "color": "#46bcec"
        },
        {
          "visibility": "on"
        }
      ]
    },
    {
      "featureType": "water",
      "elementType": "geometry.fill",
      "stylers": [
        {
          "color": "#c8d7d4"
        }
      ]
    },
    {
      "featureType": "water",
      "elementType": "labels.text.fill",
      "stylers": [
        {
          "color": "#070707"
        }
      ]
    },
    {
      "featureType": "water",
      "elementType": "labels.text.stroke",
      "stylers": [
        {
          "color": "#ffffff"
        }
      ]
    }
  ];

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style >

  #map {
    width: 100%;
    height: 450px;
  }

  /* Always set the map height explicitly to define the size of the div
   * element that contains the map. */
  .mapDisplay {
  }
  .stationDataDisplay {
    float: left;
    width: 450px;
    margin: 10px;
  }
  #map {
    height: 650px;
    width: 100%;
    border: 1px solid #cccccc;
  }

  /* Optional: Makes the sample page fill the window. */
  html, body {
    height: 100%;
    margin: 0;
    padding: 0;
  }

  .popup-container {
    position: absolute;
  }
  .fadein, .fadeout {
    opacity: 0;
    -webkit-transition: opacity 2.0s ease-in-out;
    transition: opacity 2.0s ease-in-out;
  }
  .fadein {
    opacity: 1;
  }

  .slideup, .slidedown {
      max-height: 0;
      overflow-y: hidden;
      -webkit-transition: max-height 0.5s ease-in-out;
      -moz-transition: max-height 0.5s ease-in-out;
      -o-transition: max-height 0.5s ease-in-out;
      transition: max-height 0.5s ease-in-out;
  }
  .slidedown {
      max-height: 220px ;
  }

</style>
